import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

type OrderModalHeaderProps = {
	title: React.ReactNode;
	quoteType?: string | null;
	onClose: () => void;
};

const OrderModalHeader = ({ title, quoteType, onClose }: OrderModalHeaderProps) => (
	<div className="d-flex align-items-center text-center position-relative">
		<FontAwesomeIcon
			icon={faXmark}
			size="lg"
			className="text-secondary my-auto position-absolute"
			onClick={onClose}
			style={{ cursor: 'pointer' }}
		/>
		<h2 className={quoteType ? `text-${quoteType}` : undefined} style={{ marginBottom: 0 }}>
			{title}
		</h2>
	</div>
);

export default OrderModalHeader;
